import React from 'react';

export const LiveWidgetEmbeddedContent = (props) => {
    const { embedCode } = props.options;
    return <div dangerouslySetInnerHTML={{ __html: embedCode }} />;
};
